// DropdownContext.js
import React, { createContext, useContext, useState } from "react";

const DropdownContext = createContext();

export const useDropdown = () => {
  const context = useContext(DropdownContext);
  if (!context) {
    throw new Error("useDropdown must be used within a DropdownProvider");
  }
  return context;
};

export const DropdownProvider = ({ children }) => {
  const [dropdownData, setDropdownData] = useState({
    isOpen: false,
    content: null,
    position: null,
    onOutsideClick: null,
  });

  const openDropdown = (content, position, onOutsideClick = null) => {
    setDropdownData({ isOpen: true, content, position, onOutsideClick });
  };

  const closeDropdown = () => {
    if (dropdownData.onOutsideClick) dropdownData.onOutsideClick();
    else setDropdownData({ isOpen: false, content: null, position: null, onOutsideClick: null });
  };

  return <DropdownContext.Provider value={{ dropdownData, openDropdown, closeDropdown }}>{children}</DropdownContext.Provider>;
};
